import React,{useState} from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, EmailField } from 'Components';
import i18n from 'i18next';
import './ResendMailConfirmationModel.css';

const ResendMailConfirmationModel = ({
  onProcced,
  onCancel,
  emailList,
  onChange,
  title,
  
}) => (
  <Modal show>
    <div className="confirm-modal">
      <div className="confirm-modal__container">
        <h3>{title === 'receipt' ? i18n.t('jobs:ResendReceiptModelTitle') : i18n.t('jobs:ResendModelTitle')}</h3>
        <h6>{i18n.t('jobs:ResendTitle')}</h6>
          <EmailField 
            emailString={emailList}
            setPageState={onChange}
            pageKey="resendEmailList"
            delimiter=";"
            deviceIndex={1}
            required            
          />
        <div className="confirm-modal__buttons">
          <Button onClick={onCancel} className="button button--primary">
            {i18n.t('common:Cancel')}
          </Button>
          <Button
            className="button--primary"
            onClick={() => onProcced(emailList)}
            disabled={emailList === ''}>
            {i18n.t('common:Proceed')}
          </Button>
        </div>
      </div>
    </div>
  </Modal>
);

ResendMailConfirmationModel.propTypes = {
  onProcced: PropTypes.func,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
};
ResendMailConfirmationModel.defaultProps = {
  onChange: () => null,
  emailList: '',
};

export default ResendMailConfirmationModel;



// WEBPACK FOOTER //
// ./src/components/ResendMailConfirmationModel/ResendMailConfirmationModel.jsx